import React, { useEffect, useState, memo } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
// mui
import { Stack, Box, Button } from '@mui/material';
import { hideScrollbarY } from '../../../utils/cssStyles';
import Scrollbar from '../../../components/scrollbar';
// --------------------------------------------------------------------------------------------------------------

NavSectionTab.propTypes = {
    data: PropTypes.array,
};

function NavSectionTab({ data }) {

    const [selectedIndex, setSelectedIndex] = useState(0);

    const handleClick = (index) => {
        setSelectedIndex(index);
    };

    return (
        <Scrollbar>
            <Stack direction="row" spacing={2} sx={{ p: 1, overflowX: 'auto', whiteSpace: 'nowrap', ...hideScrollbarY }}>
                {data.map((group, index) => (
                    <Box key={index} sx={{ display: 'inline-block' }}>
                        <Button
                            key={index}
                            variant='text'
                            component={RouterLink}
                            to={`${data[index].items[0]?.path}`}
                            sx={{
                                borderRadius: 0.5,
                                color: selectedIndex === index ? '#D51900' : '#6E6767',
                                px: 2, py: 0.5,
                                boxShadow: selectedIndex === index ? '3px 2px 12px 0px rgba(213, 25, 0, 0.3)' : '3px 2px 10px rgba(0, 0, 0, 0.1)',
                                backgroundColor: selectedIndex === index ? '#fff' : 'transparent',
                                zIndex: 1,
                                whiteSpace: 'nowrap',
                                textAlign: 'center',
                                '&:hover': {
                                    color: '#D51900',
                                    backgroundColor: '#fff',
                                    boxShadow: '3px 2px 12px 0px rgba(213, 25, 0, 0.3)', // Darker shadow on hover
                                },
                            }}
                            onClick={() => handleClick(index)}
                        >
                            {group.subheader}
                        </Button>
                    </Box>
                ))}
            </Stack>
        </Scrollbar>
    );
};

export default memo(NavSectionTab);
